"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioWrapper = exports.Radio = exports.LabelText = exports.HiddenLabel = exports.FullWidthWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

var _Radio = _interopRequireDefault(require("../themes/Radio.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyle__RadioWrapper",
  componentId: "sc-1yk2c7j-0"
})(function () {
  return (0, _styledComponents.css)(["min-height:2rem;position:relative;display:flex;align-items:center;", ";"], (0, _coreMixins.responsiveCalc)('padding-left', '1.25rem', '+', 2));
});

exports.RadioWrapper = RadioWrapper;

var Radio = _styledComponents["default"].input.withConfig({
  displayName: "Radiostyle__Radio",
  componentId: "sc-1yk2c7j-1"
})(function (props) {
  return (0, _styledComponents.css)(["font-size:1rem;height:2rem;left:0;opacity:0;margin:0;position:relative;top:0;width:0;&:focus{& + label:before{box-shadow:0 0 0 3px ", ";outline:3px solid transparent;}}"], props.theme.color.focus["default"]);
});

exports.Radio = Radio;

var HiddenLabel = _styledComponents["default"].span.withConfig({
  displayName: "Radiostyle__HiddenLabel",
  componentId: "sc-1yk2c7j-2"
})(function () {
  return (0, _styledComponents.css)(["", ""], (0, _coreMixins.srOnly)());
});

exports.HiddenLabel = HiddenLabel;
var labelLineHeight = 2;

var LabelText = _styledComponents["default"].label.withConfig({
  displayName: "Radiostyle__LabelText",
  componentId: "sc-1yk2c7j-3"
})(function (props) {
  var localTheme = (0, _Radio["default"])(props.theme);
  return (0, _styledComponents.css)(["font-size:", ";line-height:", "rem;&:before{content:'';position:absolute;top:", "rem;left:0;width:20px;height:20px;box-sizing:border-box;background:", ";border:1px solid ", ";border-radius:50%;transform:translateY(-50%);}&:after{content:'';position:absolute;top:", "rem;left:4px;height:12px;width:12px;opacity:0;background-color:", ";border-radius:50%;transform:translateY(-50%);transition:opacity 0.1s ease-in-out;}", " ", " ", ""], props.theme.typography.paragraph[2].fontMobile, labelLineHeight, labelLineHeight / 2, props.theme.color.monochrome1["default"], localTheme.borderColor, labelLineHeight / 2, props.disabled ? localTheme.state.disabled.checked.backgroundColor : localTheme.checked.backgroundColor, props.checked && (0, _styledComponents.css)(["&:before{border-color:", ";}&:after{opacity:1;}"], localTheme.checked.borderColor), props.disabled && (0, _styledComponents.css)(["color:", ";cursor:not-allowed;&:before{background-color:", ";border-color:", ";}"], localTheme.state.disabled.color, localTheme.state.disabled.backgroundColor, localTheme.state.disabled.borderColor), _coreMixins.respondTo.md((0, _styledComponents.css)(["font-size:", ";"], props.theme.typography.paragraph[2].fontDesktop)));
});

exports.LabelText = LabelText;

var FullWidthWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Radiostyle__FullWidthWrapper",
  componentId: "sc-1yk2c7j-4"
})(function () {
  return (0, _styledComponents.css)(["width:100%;"]);
});

exports.FullWidthWrapper = FullWidthWrapper;
//# sourceMappingURL=Radio.style.js.map